export const MOVEMENT_PARTICIPANT_LABEL_OPTIONS = [
  { key: 'missionario', singular: 'Missionário', plural: 'Missionários' },
  { key: 'participante', singular: 'Participante', plural: 'Participantes' },
  { key: 'pessoa', singular: 'Pessoa', plural: 'Pessoas' },
];

export function movementParticipantTerms(movement = {}) {
  const key = String(movement?.participant_label || 'missionario').trim().toLowerCase();
  const option = MOVEMENT_PARTICIPANT_LABEL_OPTIONS.find(item => item.key === key) || MOVEMENT_PARTICIPANT_LABEL_OPTIONS[0];
  return {
    ...option,
    singularLower: option.singular.toLowerCase(),
    pluralLower: option.plural.toLowerCase(),
    pair: `${option.singular}/${option.plural}`,
  };
}

export function movementParticipantText(text = '', movement = {}) {
  const terms = movementParticipantTerms(movement);
  return String(text || '')
    .replace(/Missionários/g, terms.plural)
    .replace(/Missionário/g, terms.singular)
    .replace(/missionários/g, terms.pluralLower)
    .replace(/missionário/g, terms.singularLower);
}